// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1__qA","cls2":"mentions_milestone_ping-cls2__XS mentions_milestone_ping-cls1__qA"};